import { Box, Button, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

export const Root = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  width: "100vw",
  position: "absolute",
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
})

export const StyledContainer = styled("div")({
  maxWidth: "28rem",
  width: "100%",
  margin: "auto 2%",
  background: "#FFFFFF",
  padding: "1.875rem",
  borderRadius: "6px",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
})

export const Title = styled(Typography)({
  fontSize: "1.2rem",
  fontWeight: 500,
  textAlign: "center",
  marginBottom: "2rem",
})

export const Subtitle = styled(Typography)(({ theme }) => ({
  fontSize: "1.1rem",
  fontWeight: 400,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(2),
  textAlign: "center",
}))

export const ContainerBtn = styled(Box)({
  display: "flex",
  justifyContent: "space-evenly",
  flexDirection: "column",
  width: "100%",
})

export const BtnConfirm = styled(Button)({
  border: "1px solid #757575",
  background: "#f26357",
  color: "#080707",
  transition: "0.2s",
  "&:hover": {
    background: "#FFFFFF",
    filter: "brightness(90%)",
  },
})

export const BtnCancel = styled(Button)({
  border: "1px solid #757575",
  background: "#4CAF50",
  color: "#080707",
  transition: "0.2s",
  marginBottom: "1rem",
  "&:hover": {
    background: "#FFFFFF",
    filter: "brightness(90%)",
  },
})
